import React from 'react';
const NotFound = () => {
    return (
        <React.Fragment>
            <h1>Page not found</h1><h2 style={{ 'color': 'var(--red)', 'marginTop': '40px' }}>Sorry we couldn't find the page you were looking for.</h2>
    <p><strong>The page you were looking for is no longer at this location. This is usually due to one of the following reasons: </strong></p>
    <ul>
        <li>It's been moved or deleted.</li>
        <li>You may have been provided the wrong web page address.</li>
        <li>It was mis-typed in the URL address bar.</li>
    </ul>
    <p>If you came to this message through a web bookmark/favourite, please delete it as it appears to be out of date.</p>
    <p><strong>To find what you are looking for:</strong></p>
    <ul>
        <li>Try the site <a href="search?sort=score&loaded=10">search</a> or click search at the top of the page.</li>
                <li>Alternatively, try the following links:<ul style={{ 'marginBottom': '50px' }}>
            <li><a href="article?sort=popularity&loaded=10">Articles</a></li>
            <li><a href="search?sort=score&options=33&loaded=5">Collections</a></li>
            <li><a href="showcase">Showcase</a></li>
            <li><a href="page/reflection-tools">Tools</a></li>
        </ul>
        </li>
            </ul>
        </React.Fragment>
        )
}
export default NotFound;